export default function () {
  return {
    canAccessOne: true,
    canAccessTwo: true,
  }
}
